import Sidebar from "../../../../components/ui/sidebar";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../components/ui/card";
import { PawPrint as PawIcon } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface Pet {
  id: number;
  name: string;
  type: string;
  breed: string;
  imageUrl: string;
  foundLocation?: string;
}

const pets: Pet[] = [
  { id: 1, name: "Douglas", type: "Canino", breed: "Pastor alemán", imageUrl: "https://via.placeholder.com/50?text=Douglas", foundLocation: "Portería" },
  { id: 2, name: "Felix", type: "Felino", breed: "Gonoara", imageUrl: "https://via.placeholder.com/50?text=Felix" },
];

export default function PetsPage() {
  const navigate = useNavigate();
  const [selectedPet, setSelectedPet] = useState<Pet | null>(null);

  const openModal = (pet: Pet) => {
    setSelectedPet(pet);
  };

  const closeModal = () => {
    setSelectedPet(null);
  };

  const handleCreatePet = () => {
    navigate("/PetsPage/CreatePetPage");
  };

  return (
    <div className="flex min-h-screen bg-gray-100 text-gray-900">
      <Sidebar />
      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Mascotas</h2>
        <Card className="shadow-lg border-l-4 border-purple-500">
          <CardHeader>
            <CardTitle>Lista de Mascotas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {pets.map((pet) => (
                <div
                  key={pet.id}
                  onClick={() => openModal(pet)}
                  className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm hover:bg-gray-50 cursor-pointer"
                >
                  <div className="flex items-center gap-4">
                    <img src={pet.imageUrl} alt={pet.name} className="w-12 h-12 rounded-full object-cover" />
                    <div>
                      <p className="font-medium">{pet.name}</p>
                      <p className="text-sm text-gray-600">{pet.type} - {pet.breed}</p>
                    </div>
                  </div>
                  <PawIcon size={24} className="text-purple-500" />
                </div>
              ))}
            </div>
            <button
              onClick={handleCreatePet}
              className="mt-4 w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition"
            >
              +
            </button>
          </CardContent>
        </Card>

        {/* Modal de Detalle */}
        {selectedPet && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
              <h3 className="text-xl font-bold mb-4">Detalle mascota</h3>
              <div className="flex justify-center mb-4">
                <img src={selectedPet.imageUrl} alt={selectedPet.name} className="w-32 h-32 object-cover rounded" />
              </div>
              <div className="space-y-2">
                <p><strong>Nombre:</strong> {selectedPet.name}</p>
                <p><strong>Tipo:</strong> {selectedPet.type}</p>
                <p><strong>Raza:</strong> {selectedPet.breed}</p>
                {selectedPet.foundLocation && (
                  <p><strong>Fue encontrado:</strong> {selectedPet.foundLocation}</p>
                )}
              </div>
              <button
                onClick={closeModal}
                className="mt-6 w-full bg-gray-500 text-white py-2 rounded-full hover:bg-gray-600 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}